import { render, staticRenderFns } from "./alarmuser.vue?vue&type=template&id=669ad5d2&scoped=true"
import script from "./alarmuser.vue?vue&type=script&lang=js"
export * from "./alarmuser.vue?vue&type=script&lang=js"
import style0 from "./alarmuser.vue?vue&type=style&index=0&id=669ad5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ad5d2",
  null
  
)

export default component.exports